import React from 'react';
import ResizeAware from 'react-resize-aware';

import { primary, bright } from '../colors';
import { h4, h3, h5 } from '../fontSizes';
import { smallMargin } from '../margins';
import { minWidth, tablet, desktopMedium } from '../screenSizes';

export const MarketingRender = ({
  title,
  text,
  price,
  width,
  getRef,
  children,
}) => (
  <div
    ref={getRef}
    css={`
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;
      text-align: center;
      width: auto;
      max-width: 200px;
      right: 5%;
      bottom: 10%;
      padding: 20px;
      height: ${width ? `${width}px` : 'auto'};
      border-radius: 50%;
      background-color: ${primary};
      color: ${bright};

      ${minWidth(tablet)} {
        max-width: 300px;
      }

      ${minWidth(desktopMedium)} {
        max-width: 400px;
      }
    `}
  >
    {children}
    <div
      css={`
        padding: 10px;
      `}
    >
      <h3
        css={`
          font-size: ${h4};
          text-transform: uppercase;
          font-weight: bold;
          margin-top: 10%;
          margin-bottom: ${smallMargin};

          ${minWidth(tablet)} {
            font-size: ${h3};
          }
        `}
      >
        {title}
      </h3>
      <p
        css={`
          font-weight: 300;
          margin-bottom: calc(${smallMargin} / 2);

          ${minWidth(tablet)} {
            font-size: ${h5};
          }
        `}
      >
        {text}
      </p>
      <div
        css={`
          font-weight: 700;

          ${minWidth(tablet)} {
            font-size: ${h5};
          }
        `}
      >
        {price} kr
      </div>
    </div>
  </div>
);

export const Marketing = props => (
  <ResizeAware component={MarketingRender} {...props} />
);



// WEBPACK FOOTER //
// ./app/components/Marketing.js